import { gql } from "@apollo/client";

export const GetRfqTrns = gql`
  query GetRfqTrns(
    $token: String!
    $customerId: ID!
    $finYrId: ID!
    $after: Cursor
    $rfqID: ID!
    $supplierId: ID!
    $queryType: RfqTrnQueryType!
    $orderBy: AtsRfqTrnOrder
  ) {
    GetRfqTrns(
      token: $token
      customerId: $customerId
      finYrId: $finYrId
      after: $after
      rfqID: $rfqID
      supplierId: $supplierId
      queryType: $queryType
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          slNo
          trnDate
          udfItemDesc
          trnQty
          approxRate
          priority
          preferredSupplierIds
          trnNeedBefore
          itemTerms
          itemPaymentTerms
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GetRfqTrnSupply = gql`
  query GetRfqTrnSupply(
    $token: String!
    $customerId: ID!
    $finYrId: ID!
    $rfqId: ID!
    $queryType: RfqSupplyQueryType!
    $start_date: Time!
    $end_date: Time!
    $after: Cursor
    $orderBy: AtsRfqTrnSupplyOrder
    $name: Boolean
  ) {
    GetRfqTrnSupply(
      token: $token
      customerId: $customerId
      finYrId: $finYrId
      rfqId: $rfqId
      queryType: $queryType
      start_date: $start_date
      end_date: $end_date
      after: $after
      orderBy: $orderBy
      where: { or: [{ negoStatus: $name }] }
    ) {
      edges {
        node {
          id
          slNo
          rfqTrnSlNo
          isAccepted
          itemDescChanged
          quotedAnyChanges
          quotedDesc
          quotedQty
          quotedRate
          quotedOther
          quotedTaxable
          quotedTax
          quotedDelvChrg
          quotedInstChrg
          quotedValue
          quotedRemarks
          quotedProductBrochure
          negoStatus
          negoQty
          negoRate
          negoOther
          negoTaxable
          negoTax
          negoDelvChrg
          negoInstChrg
          negoValue
          negoRemarks
          customerID
          itemID
          rfqTrnID
          rfqID
          negoValue
          negoRemarks
          customerID
          itemID
          rfqTrnID
          rfqID
          rfq {
            rfqNo
          }
          rfqTrn {
            id
            slNo
            trnDate
            udfItemDesc
            trnQty
            approxRate
            priority
            preferredSupplierIds
            trnNeedBefore
            itemTerms
            itemPaymentTerms
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const RfqTrnSupplyByNode = gql`
  query AtsRfqTrnSupply($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsRfqTrnSupply {
        id
        itemDescChanged
        isAccepted
        quotedDesc
        quotedQty
        quotedRate
        quotedAnyChanges
        quotedTax
        quotedDelvChrg
        quotedInstChrg
        quotedValue
        quotedRemarks
        quotedOther
        quotedCompleted
        negoStatus
        negoQty
        negoRate
        negoOther
        negoTaxable
        negoTax
        negoDelvChrg
        negoInstChrg
        negoValue
        negoRemarks
        rfq {
          lastDateRfqSubmission
          rfqNo
          remarks
          generalTerms
          generalPaymentTerms
        }
        ldgrID
        rfqTrn {
          id
          udfItemDesc
          itemTerms
          itemPaymentTerms
          mrf_trn_details {
            reqQty
            remarks
          }
          preferedSupplierDetails {
            id
            desc
            supplier_details {
              city
              gstNo
              panNo
            }
          }
        }
        supplierDetails {
          id
          desc
          supplier_details {
            city
            gstNo
            panNo
          }
        }
      }
    }
  }
`;
